import {
  createColumnVisibilityStore,
  type ColumnDefinition,
} from "./createColumnVisibilityStore";

/**
 * The resource-actions table's columns, in render order.
 *
 * Labels match the table headers exactly — the menu is a list of what is on screen, so a
 * different wording there reads as a different column.
 *
 * Three are locked: `index` carries the row number an operator uses to point at a row, `resource`
 * is the only thing that says which machine this row is about (name, VM UUID, and the "Deleted"
 * badge when the resource itself is gone), and `actions` is where View lives. `user` and
 * `duration` start hidden — the tenant + resource + action + status already identify a row, and
 * both cost width most operators will not ask for on a first look.
 *
 * `description` is visible by default and earns its width: one provisioning attempt writes two
 * Provision rows — the request sent to WiService and the provisioning that followed it — and the
 * type and status badges are identical on both. Without it the pair reads as a duplicate.
 */
export const RESOURCE_ACTION_COLUMNS = [
  { id: "index", label: "No.", locked: true },
  { id: "createdAt", label: "Created" },
  { id: "resource", label: "Resource", locked: true },
  { id: "type", label: "Action" },
  { id: "status", label: "Status" },
  { id: "description", label: "Description" },
  { id: "tenant", label: "Tenant" },
  { id: "user", label: "User", hiddenByDefault: true },
  { id: "duration", label: "Duration", hiddenByDefault: true },
  { id: "error", label: "Error" },
  { id: "actions", label: "Actions", locked: true },
] as const satisfies readonly ColumnDefinition[];

export type ResourceActionColumnId = (typeof RESOURCE_ACTION_COLUMNS)[number]["id"];

export const useResourceActionColumnsStore =
  createColumnVisibilityStore<ResourceActionColumnId>({
    name: "admin.resourceActions.columns",
    columns: RESOURCE_ACTION_COLUMNS,
  });
